import React, { useEffect, useState, useCallback, memo, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import GridColumnSettingControl from "../FilterOptions/GridColumnSettingControl";
import CopyBox from "../MessageBox/CopyBox";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import equipmentActions from "../../Actions/EquipmentActions";
import EquipmentPopOver from "./EquipmentPopOver";
import MessageBox from "../MessageBox/MessageBox";
import DeleteEquipment from "./DeleteEquipment";
import MultiPalPruefPlan from "./MultiPalPruefPlan";
import OrderHistroy from "../Navigationsbar/Nav-Details/OrderHistroy";
import MuiDataGridPro from "./MuiDataGridPro";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { Delete, Info, Add } from "@mui/icons-material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DetailsIcon from "@mui/icons-material/Details";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import equipmentGroupStore from "../../Stores/EquipmentGroupStore";
import equipmentGroupConstants from "../../Constants/EquipmentGroupConstants";
import equipmentGroupActions from "../../Actions/EquipmentGroupActions";
import { toast } from "react-toastify";
import { flushSync } from "react-dom";

import {
  attachFilter,
  attachingDropDown,
  CompareFilter,
  DropDownChange,
  dropDownFilter,
  extractFilterOperator,
  FilterApplyHandle,
  filterModel,
} from "./MuiDataGridPro/HelperDashboard";
import { _helper } from "../GlobalFunction/dateHelper";
import {
  useAMGSelectedContext,
  useChildInfoActionContext,
  useMainGridSortActionContext,
  useMainGridSortContext,
} from "../../Context/GlobalContext";
import { Tooltip } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import PauseIcon from "@mui/icons-material/Pause";
import TimelineIcon from "@mui/icons-material/Timeline";
import GridHeaderBar from "./MuiDataGridPro/GridHeaderBar";
import {
  useEquipmentStatusActionsContext,
  useEquipmentStatusContext,
  useItemSelectedFilterActionsContext,
  useItemSelectedFilterContext,
  useSelectedFilterActionsContext,
} from "../../Context/GridEquipListContext";

import equipmentStore from "../../Stores/EquipmentStore";
import equipmentConstants from "../../Constants/EquipmentConstants";
import { TourGuideHelper } from "../../helpers/TourGuide/TourGuideHelper";
import {
  useTourGuidSavedSettingActionsContext,
  useTourGuidSavedSettingContext,
  useTourGuidStartActionsContext,
} from "../../Context/TourGuidContext";
import commonUtils from "../../helpers/commonUtils";
import GridColumn_SettingActions from "../../Actions/GridColumn_SettingActions";
import gridColSettingStore from "../../Stores/GridColumn_SettingStores";
import GridColSettingConstants from "../../Constants/GridColumn_SettingConstants";
import { CreateFilterModel } from "./MuiDataGridPro/SaveUserFilter";
import AppConstants from "../../Constants/AppConstants";
var dateFormat = require("dateformat");
const copyBoxInitial = {
  messageBoxText: {},
  msgButtons: [],
  copyboxOpen: false,
  copyAnzahl: null,
};

const messageBoxInitial = {
  messageBoxText: {},
  msgButtons: [],
  messageBoxOpen: false,

  delequipmentDetails: {},
  isOpenDeletePopOver: false,
};
const EquipmentListTable = memo(
  ({
    saveFilterList,
    reportCode,
    handlePaginationCallApi,
    handleOpenEquipmentGrpConf,
  }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const sortBy = useMainGridSortContext();
    const UpdateSortBy = useMainGridSortActionContext();
    const selectedAnlageG = useAMGSelectedContext();
    const itemSelectedFilter = useItemSelectedFilterContext();
    const updateListSelectedFilter = useItemSelectedFilterActionsContext();
    const updateChildInfo = useChildInfoActionContext();
    const equipmentStatus = useEquipmentStatusContext();
    const updateEquipmentStatus = useEquipmentStatusActionsContext();
    const setGlobalSpinner = useGlobalSpinnerActionsContext();
    const UpdateTourStatus = useTourGuidStartActionsContext();
    const tourGuidSaveSetting = useTourGuidSavedSettingContext();
    const setTourGuidSaveSetting = useTourGuidSavedSettingActionsContext();
    const { localization } = useLanguageContext();
    const updateSelectedFilter = useSelectedFilterActionsContext();
    const [showGridColumn, setShowGridColumn] = useState(false);
    const [selectedEqList, setSelectedEqList] = useState(null);
    const [shouldFetch, setShouldFetch] = useState(false);
    const [apiArgs, setApiArgs] = useState(null);

    const [orderHistroy, setOrderHistroy] = useState({
      isOpen: false,
      eqID: "",
    });
    const [equipmentPopover, setEquipmentPopover] = useState({
      selectedItem: null,
      isOpen: false,
    });
    const [copyBoxProperty, setCopyBoxProperty] = useState(copyBoxInitial);
    const [messageBoxProperty, setMessageBoxProperty] =
      useState(messageBoxInitial);
    const [multiplePruefPlan, setMultiplePruefPlan] = useState({
      isOpen: false,
      selectedItem: null,
    });
    const [saveFilterlist, setSaveFilterList] = useState([]);
    const [tableData, setTableData] = useState(null);
    const [state, setState] = React.useState(
      reportCode === "EquipList" ? "Active" : "Last 30 days",
    );

    const [pinnedColumns, setPinnedColumns] = React.useState({
      left: [],
      right: [],
    });
    const [clearFilterKey, setClearFilterKey] = React.useState(0);
    const itemSelectedFilterRef = useRef();
    const getActions = (params, actionList, headerList) => {
      const _actionList = [];
      if (actionList.length > 0) {
        actionList.forEach((action, index) => {
          const isMatchingCondition =
            params.row.IsEqipmentActive &&
            action.name.toLowerCase() === "active";
          if (!isMatchingCondition) {
            _actionList.push(
              <GridActionsCellItem
                key={index}
                icon={
                  {
                    ViewEquipmentDetails: <DetailsIcon />,
                    AddChildren: <Add />,
                    Active: <NotificationsIcon />,
                    CopyEquipment: <ContentCopyIcon />,
                    DeleteEquipment: <Delete />,
                    History: <TimelineIcon />,
                  }[action.name] || <Info />
                }
                label={action.text}
                onClick={() => {
                  handleAction(
                    action.name,
                    params.row,
                    headerList,
                    params.row.IsEqipmentActive,
                    params.row.hasChildren,
                  );
                }}
                showInMenu
              />,
            );
          }
        });
      }
      return _actionList;
    };

    const handleResponse = React.useCallback(
      (_response) => {
        if (_response) {
          let headerName = [];
          let paginationData = null;
          let _header = _response.headers;
          let _rows = _response.rows;
          let _action = _response.actions;
          let indexofcolToSkipdata = 0;
          _header.map((item, index) => {
            if (!item.isVisible) {
              indexofcolToSkipdata = index;
            }
            headerName.push(item.name);
          });

          paginationData = {
            pageSizeOptions: [50, 100, 500, 1000],
            rowCount: _response.pagingInfo.rowCount,
            currentPage: _response.pagingInfo.currentPage,
            pageSize: _response.pagingInfo.pageSize,
          };

          let _gridAction = null;
          if (_action.length > 0) {
            let _items = {};
            _action.map((item, i) => {
              switch (item.name) {
                case "DataConfiguration":
                  _items["DataConfiguration"] = item;
                  break;
                case "BulkUpdate":
                case "BulkDelete":
                case "BulkStatusUpdate":
                  if (!_items["Bulk"]) {
                    _items["Bulk"] = { option: [] };
                  }
                  _items["Bulk"].option.push(item);
                  break;
                case "ExcelExport":
                  _items["ExcelExport"] = item;
                  break;
                case "AddEquipment":
                  _items["AddEquipment"] = item;
                  break;
                case "EquipmentGroupConfiguration":
                  _items["EquipmentGroupConfiguration"] = item;
                  break;
              }
            });
            _gridAction = {
              actionName: _items,

              filterList: _response.filters,
              show: true,
              pageInfo: {
                currentpage: _response.pagingInfo.currentPage,
                pagSize: _response.pagingInfo.pageSize,
              },
            };
          }
          let firstItemOfColumn = null;
          const formattedData = _rows.map((row, index) => {
            const rowData = {};
            row.forEach((cell, cellIndex) => {
              if (cellIndex > indexofcolToSkipdata)
                if (cellIndex === indexofcolToSkipdata + 1) {
                  firstItemOfColumn = headerName[cellIndex];
                }
              rowData[headerName[cellIndex]] = cell.value;
              if (cell.stype) {
                rowData[headerName[cellIndex] + "stype"] = cell.stype;
              }
            });

            // Create unique key combining original ID with index to handle duplicate IDs from API
            //const uniqueKey = `${row[0].value}-${index}`;

            return {
              id: reportCode == "EquipList" ? row[0].value : row[1].value,
              originalId: row[0].value,
              ...rowData,
              rowIndexTracker: index,
              hasChildren: row[1].value,
              IsEqipmentActive: row[2].value === "1" ? true : false,
            };
          });

          let actionItem = null;
          let headerNameWithType = {};
          const coliumns = _response.headers
            .filter((col) => col.isVisible) // Only show visible columns
            .map((col, index) => {
              if (col.actions.length > 0) {
                actionItem = [...col.actions];
              }
              headerNameWithType[col.name] = col.type.toLowerCase();
              const colDefination = {
                field: col.name, // Unique field name for DataGrid
                headerName: col.text, // Displayed text
                minWidth: col.type.toLowerCase() === "bool" ? 50 : 100,
                flex: 1,
                headerClassName: col.name,
                filterable: col.name === "ChecklistFrequency" ? false : true,
                type: ["anlagestatus", "nio", "inspectionresult"].includes(
                  col.name.toLowerCase(),
                )
                  ? "singleSelect"
                  : col.type.toLowerCase() === "bool"
                    ? "boolean"
                    : ["int", "float"].includes(col.type.toLowerCase())
                      ? "number"
                      : col.type.toLowerCase() === "datetime"
                        ? "date"
                        : "string",
                filterOperators: extractFilterOperator(
                  col.type,
                  col.name,
                  localization,
                ),
                valueGetter:
                  col.type.toLowerCase() === "datetime"
                    ? (params) => {
                        const cellValue = params.row[col.name];
                        return cellValue; // Convert to Date object
                      }
                    : undefined,
                valueFormatter: (params) => {
                  if (
                    ["anlagestatus", "nio", "inspectionresult"].includes(
                      params.field.toLowerCase(),
                    )
                  ) {
                    if (params.field.toLowerCase() === "anlagestatus") {
                      return params.value.toLowerCase() === "inbe"
                        ? localization.active
                        : localization.inActive;
                    } else if (
                      ["nio", "inspectionresult"].includes(
                        params.field.toLowerCase(),
                      )
                    ) {
                      return params.value.toLowerCase() === "true"
                        ? localization.nio
                        : localization.io;
                    }
                  }
                  return params.value;
                },
                renderCell: (params) => {
                  const rowIndex = params.row.id; // Get row index to match the rowData
                  let cellData = params.row[col.name]; // Get cell value
                  const cellColor =
                    params.row[col.name + "stype"] || "transparent"; // Get background color

                  if (col.actions.length > 0) {
                    actionItem = col.actions;
                  }
                  if (
                    ["anlagestatus", "nio", "inspectionresult"].includes(
                      col.name.toLowerCase(),
                    )
                  ) {
                    let backgroundColor;
                    let textColor = "#000"; // Default text color
                    let icon = null;
                    let tooltipText = "";
                    let nioText = "";
                    if (col.name.toLowerCase() === "anlagestatus") {
                      const isValueOk = cellData.toLowerCase() === "inbe";
                      cellData = isValueOk
                        ? localization.active
                        : localization.inActive;
                      icon = isValueOk ? (
                        <DoneIcon style={{ color: "#0A470A" }} />
                      ) : (
                        <CloseIcon style={{ color: "#A00" }} />
                      );
                      backgroundColor = isValueOk ? "#E3FBE3" : "#FBE3E3";
                      textColor = isValueOk ? "#0A470A" : "#A00";
                      tooltipText = isValueOk
                        ? localization.eqIsActive
                        : localization.eqIsNotActive;
                    } else if (
                      ["nio", "inspectionresult"].includes(
                        col.name.toLowerCase(),
                      )
                    ) {
                      backgroundColor =
                        cellData.toLowerCase() === "true"
                          ? "#FBE3E3"
                          : "#E3FBE3";
                      textColor =
                        cellData.toLowerCase() === "true" ? "#A00" : "#0A470A";

                      nioText =
                        cellData.toLowerCase() === "true"
                          ? localization.nio
                          : localization.io;
                    }

                    return (
                      <Tooltip title={tooltipText}>
                        <div
                          style={{
                            backgroundColor: backgroundColor, // Apply dynamic background color
                            padding: "0 6px 0 6px",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "15px",

                            color: textColor, // Dynamic text color
                          }}
                        >
                          {icon && <span>{icon}</span>}
                          <span>{nioText === "" ? cellData : nioText}</span>
                        </div>
                      </Tooltip>
                    );
                  } else {
                    return (
                      <div
                        style={{
                          backgroundColor: cellColor, // Apply background color from stype
                          padding: "5px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <span className="tableCellTextStyle" title={cellData}>
                          {cellData}
                        </span>
                      </div>
                    );
                  }
                },
                cellClassName: (params) => {
                  let cellColor = params.row[col.name + "stype"];
                  cellColor = cellColor
                    ? cellColor === "#F7C5C5"
                      ? "backgroundColorF7 MuiDataGridfdsfsd"
                      : "backgroundColorFc MuiDataGridfdsfsd"
                    : "MuiDataGridfdsfsd";

                  return cellColor;
                },
              };
              if (["anlagestatus"].includes(col.name.toLowerCase())) {
                colDefination.valueOptions = [
                  { value: "INBE", label: localization.active },
                  { value: "AUSSER BETRIEB", label: localization.inActive },
                ];
              } else if (
                ["nio", "inspectionresult"].includes(col.name.toLowerCase())
              ) {
                colDefination.valueOptions = [
                  { value: "true", label: localization.nio },
                  { value: "false", label: localization.io },
                ];
              }
              return { ...colDefination };
            });
          coliumns.splice(1, 0, {
            field: "actions",
            type: "actions",
            width: 45,
            //flex: 1,
            hideable: false,
            headerName: localization.actions,
            getActions: (params) =>
              getActions(params, actionItem, _response.headers),
          });
          const _columnItem =
            reportCode === "EquipList" ? "InventarNr" : "pruefdatum";
          const filterModelTable =
            itemSelectedFilterRef?.current.length > 0
              ? filterModel(
                  itemSelectedFilterRef?.current,
                  reportCode,
                  headerNameWithType,
                )
              : { items: [] };
          setTableData({
            columns: coliumns,
            data: formattedData,
            paginationData: { ...paginationData },
            gridAction: _gridAction,
            headerName: headerName,
            sortingModal: [
              {
                field:
                  sortBy.key && headerName.includes(sortBy.key)
                    ? sortBy.key
                    : headerName.includes(_columnItem)
                      ? _columnItem
                      : firstItemOfColumn,
                sort: sortBy.order === "" ? "asc" : sortBy.order,
              },
            ],
            filterModel: filterModelTable,
            hearderType: headerNameWithType,
          });
          if (reportCode === "EquipList" && commonUtils.isPrufer()) {
            const tourStatus = TourGuideHelper.returnCurrentTourState(
              tourGuidSaveSetting,
              setTourGuidSaveSetting,
              "welcometour",
            );

            if (tourStatus.length > 0) {
              UpdateTourStatus({
                tourTitle: tourStatus[0].title,
                tourStatus: true,
                anyStep: 0,
              });
            }
          }
        }
      },
      [sortBy, itemSelectedFilter],
    );
    const handleColumnPin = React.useCallback((_value) => {
      setPinnedColumns(_value);
    }, []);

    React.useEffect(() => {
      itemSelectedFilterRef.current = itemSelectedFilter;
    }, [itemSelectedFilter]);

    // bump clearFilterKey when selected equipment group changes so child grid can clear its UI filters
    React.useEffect(() => {
      setClearFilterKey((k) => k + 1);
    }, [selectedAnlageG]);

    useEffect(() => {
      function getSaveFilterResultSuccess() {
        var res = gridColSettingStore.getSaveFilterResult();

        // updateSelectedFilter("");
        if (res.length > 0) {
          setSaveFilterList(res);
        } else {
          setSaveFilterList([]);
        }
      }

      function SaveFilterResultFailure() {}

      gridColSettingStore.addChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_LIST_SUCCESS,
        getSaveFilterResultSuccess,
      );

      gridColSettingStore.addChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_LIST_FAILURE,
        SaveFilterResultFailure,
      );
      return () => {
        gridColSettingStore.removeChangeListener(
          GridColSettingConstants.GET_SAVE_FILTER_LIST_SUCCESS,
          getSaveFilterResultSuccess,
        );

        gridColSettingStore.removeChangeListener(
          GridColSettingConstants.GET_SAVE_FILTER_LIST_FAILURE,
          SaveFilterResultFailure,
        );
      };
    }, []);
    useEffect(() => {
      function getFilterSaveSuccess() {
        var res = gridColSettingStore.getSavedFilterResult();
        if (res) {
          const _parseRes = JSON.parse(res[["settingValue"]]);
          GridColumn_SettingActions.getSaveFilterList(
            sessionStorage.getItem("eqGId"),
            reportCode,
          );

          const _filterList = CreateFilterModel(
            [..._parseRes],
            reportCode,
            tableData.hearderType,
          );
          updateSelectedFilter([
            {
              id: res["id"],
              title: res["title"],
            },
          ]);
          updateListSelectedFilter(_filterList);
          equipmentGroupActions.getEquipmentList2(
            reportCode,
            sortBy.order,
            selectedAnlageG,
            parseInt(1),
            parseInt(tableData.paginationData.pageSize),
            sortBy.key,
            null,
            _filterList,
          );
          //getEquipmentList(false, JSON.parse(res["id"]));
          toast.success(localization.filterSave);
        }
      }

      function getFilterSaveFailure() {
        var res = gridColSettingStore.getSavedFilterResult();
        toast.error(res);
        setGlobalSpinner(false);
      }

      gridColSettingStore.addChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_SUCCESS,
        getFilterSaveSuccess,
      );

      gridColSettingStore.addChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_FAILURE,
        getFilterSaveFailure,
      );
      return () => {
        gridColSettingStore.removeChangeListener(
          GridColSettingConstants.SAVE_GRID_FILTER_SUCCESS,
          getFilterSaveSuccess,
        );
        gridColSettingStore.removeChangeListener(
          GridColSettingConstants.SAVE_GRID_FILTER_FAILURE,
          getFilterSaveFailure,
        );
      };
    }, [tableData]);

    useEffect(() => {
      if (
        location.pathname === "/equipmentGrpEqiupment" &&
        equipmentStatus !== "not"
      ) {
        setState(equipmentStatus);
      } else {
        setState(
          location.pathname === "/inspection" ? "Last 30 days" : "Active",
        );
      }
      setPinnedColumns({
        left: [],
        right: [],
      });
    }, [location.pathname, selectedAnlageG]);

    useEffect(() => {
      if (!shouldFetch || !apiArgs) return;

      console.log("selectedAnlageG at effect time:", selectedAnlageG);

      setGlobalSpinner(true);

      const _tempFilterlist = attachingDropDown(
        [...(apiArgs.rawFilterList || [])],
        state,
        reportCode,
      );

      equipmentGroupActions.getEquipmentList2(
        reportCode,
        apiArgs.isSorting
          ? apiArgs.sortingModal[0]["sort"]
          : sortBy.order || "asc",
        selectedAnlageG,
        parseInt(apiArgs.page),
        parseInt(apiArgs.pageSize),
        apiArgs.isSorting
          ? apiArgs.sortingModal[0]["field"]
          : sortBy.key !== ""
            ? sortBy.key
            : reportCode === "EquipList"
              ? "InventarNr"
              : "pruefdatum",
        null,
        _tempFilterlist,
      );

      setShouldFetch(false);
    }, [shouldFetch, apiArgs, selectedAnlageG, state, reportCode]);

    useEffect(() => {
      function updateEquipmentList() {
        setTableData(null);
        updateChildInfo({
          equipId: AppConstants.DEFAULT_GUID,
          inventarnr: "",
          bezeichnung: "",
        });
        const res = equipmentGroupStore.getEquipmentListGrid();
        handleResponse(res);
        setGlobalSpinner(false);
      }
      equipmentGroupStore.addChangeListener(
        equipmentGroupConstants.GET_GRID_EQUIPMENTLIST_SUCCESS,
        updateEquipmentList,
      );

      return () => {
        equipmentGroupStore.removeChangeListener(
          equipmentGroupConstants.GET_GRID_EQUIPMENTLIST_SUCCESS,
          updateEquipmentList,
        );
      };
    }, [sortBy]);

    const goToNextPage = useCallback(
      (rowid, rowbez, rowinvnr) => {
        const _pathName = location.pathname.startsWith("/equipmentGrpEqiupment")
          ? "/equipmentGrpEqiupment/"
          : "/inspection/";

        let _rowbez =
          rowbez !== null && rowbez !== undefined && rowbez.length !== 0
            ? rowbez
            : "undefined";
        _rowbez = _rowbez.includes("/") ? _rowbez.replace("/", "\\") : _rowbez;
        const path = `${_pathName}${sessionStorage.getItem(
          "eqBez",
        )}/${rowid}/${_rowbez}/${rowinvnr}`;
        navigate(path);
      },
      [navigate, location.pathname],
    );

    const handelSelectedRow = useCallback(
      (row) => {
        sessionStorage.setItem("eqId", row.id);
        sessionStorage.setItem("invnr", row.inventarnr);
        goToNextPage(row.id, row.bezeichnung, row.inventarnr);
      },
      [goToNextPage],
    );
    const handleRowDoubleClick = useCallback(
      (params) => {
        const row = {
          id: params.row.originalId,
          inventarnr: params.row.InventarNr,
          bezeichnung: params.row.Bezeichnung,
        };
        handelSelectedRow(row);
      },
      [handelSelectedRow],
    );
    const handleCheckBoxClick = useCallback((eqId) => {
      setSelectedEqList((prev) => {
        if (prev && prev.includes(eqId)) {
          const _temp = prev.filter((item) => item !== eqId);
          return _temp.length > 0 ? _temp : null;
        } else {
          return prev ? [...prev, eqId] : [eqId];
        }
      });
    }, []);

    const closeMsg = useCallback(() => {
      setCopyBoxProperty(copyBoxInitial);
    }, []);

    const copyConfirm = useCallback(
      (selectedValue, id) => {
        closeMsg();
        setGlobalSpinner(true);
        equipmentActions.copyEquipment(
          id,
          selectedValue,
          sessionStorage.getItem("userid"),
        );
      },
      [closeMsg, setGlobalSpinner],
    );

    const handelCopy = useCallback(
      (item) => {
        setCopyBoxProperty({
          messageBoxText: {
            title: `${item.inventarnr} ${localization.copyTitle}?`,
            msg: localization.copyMsg,
            anlageID: item.id,
          },
          msgButtons: [
            {
              title: localization.cancelbutton,
              func: closeMsg,
              type: "cancel",
            },
            {
              title: localization.copyTitle,
              func: copyConfirm,
              type: "ok",
            },
          ],
          copyboxOpen: true,
          copyAnzahl: "",
        });
      },
      [copyConfirm, localization],
    );

    const deleteConfirm = useCallback(
      (id, haschildren) => {
        setMessageBoxProperty((prev) => {
          return {
            ...prev,
            delequipmentDetails: {
              id: id,
              status: "VERSCHROTTET",
              hasChildren:
                haschildren && haschildren.toLowerCase() === "true"
                  ? true
                  : false,
            },
            isOpenDeletePopOver: true,
          };
        });
      },
      [closeMsg, setGlobalSpinner],
    );

    const außerbetrieb = (id) => {
      setMessageBoxProperty(messageBoxInitial);
      setGlobalSpinner(true);
      equipmentActions.deleteEquipment(id, "AUSSERBETRIEB", null);
    };

    const handelDelete = useCallback(
      (item, isEquipmentActive, hasChildren) => {
        setMessageBoxProperty((prev) => {
          return {
            ...prev,

            messageBoxText: {
              title: item.inventarnr + "  " + localization.deleteTitle,
              msg: isEquipmentActive
                ? localization.deleteMsg
                : localization.deleteEquipmentMsg,
              anlageID: item.id,
              haschildren: hasChildren,
            },
            msgButtons: [
              {
                title: localization.cancelbutton,
                func: () => {
                  setMessageBoxProperty(messageBoxInitial);
                },
              },
              ...(isEquipmentActive
                ? [
                    {
                      title: localization.außerbetriebbutton,
                      func: außerbetrieb,
                    },
                  ]
                : []),
              { title: localization.delete, func: deleteConfirm },
            ],
            messageBoxOpen: true,
          };
        });
      },
      [deleteConfirm, localization],
    );

    function handelAdd(item) {
      setEquipmentPopover({
        selectedItem: item,
        isOpen: true,
      });
    }

    const handleAction = useCallback(
      (
        actionName,
        rowselected,
        headerNameList,
        isEquipmentActive,
        hasChildren,
      ) => {
        const row = {
          id: rowselected.originalId,
          inventarnr: rowselected.InventarNr,
          bezeichnung: rowselected.Bezeichnung,
        };
        switch (actionName) {
          case "ViewEquipmentDetails":
            //sessionStorage.setItem("rowselected", JSON.stringify(rowselected));
            handelSelectedRow(row);
            break;
          case "CopyEquipment":
            handelCopy(row);
            break;
          case "AddChildren":
            handelAdd(row);
            break;
          case "DeleteEquipment":
            handelDelete(row, isEquipmentActive, hasChildren);
            break;
          case "TestPlanDetail":
            setMultiplePruefPlan({ isOpen: true, selectedItem: row });
            break;
          case "History":
            setOrderHistroy({ isOpen: true, eqID: row.id });
            break;

          case "Active":
            handleMultipleActive(row);
            break;
        }
      },
      [handelSelectedRow, handelCopy],
    );

    const handleCloseGridColSettingModal = useCallback(() => {
      setShowGridColumn(false);
    }, []);

    // const handleEquipmentListApi = React.useCallback(
    //   (filterList, page, pageSize, isSorting, sortingModal) => {
    //     setGlobalSpinner(true);

    //     equipmentGroupActions.getEquipmentList2(
    //       reportCode,
    //       isSorting
    //         ? sortingModal[0]["sort"]
    //         : sortBy.order
    //           ? sortBy.order
    //           : "asc",
    //       selectedAnlageG,
    //       parseInt(page),
    //       parseInt(pageSize),
    //       isSorting
    //         ? sortingModal[0]["field"]
    //         : sortBy.key !== ""
    //           ? sortBy.key
    //           : reportCode === "EquipList"
    //             ? "InventarNr"
    //             : "pruefdatum",

    //       null,
    //       filterList,
    //     );
    //   },
    //   [sortBy],
    // );

    useEffect(() => {
      function refreshTable() {
        var res = equipmentStore.getResult();
        let msg = "";
        if (res && res.length) {
          msg = "" + localization.copySuccess + "\n" + res.join();
        } else {
          msg = "" + localization.copySuccess + "\n" + res;
        }
        const _tempFilterlist = attachingDropDown(
          [...itemSelectedFilter],
          state,
          reportCode,
        );
        // handleEquipmentListApi(
        //   _tempFilterlist,
        //   tableData.paginationData.currentPage,
        //   tableData.paginationData.pageSize,
        // );
        setApiArgs((prev) => ({
          ...prev,
          page: tableData.paginationData.currentPage,
          pageSize: tableData.paginationData.pageSize,
          rawFilterList: _tempFilterlist,
        }));
        setShouldFetch(true);

        toast.success(msg);
      }
      function refreshTableFailurCopy() {
        setGlobalSpinner(false);
        toast.error(localization.copyFailure);
      }

      equipmentStore.addChangeListener(
        equipmentConstants.COPY_EQUIPMENT_SUCCESS,
        refreshTable,
      );
      equipmentStore.addChangeListener(
        equipmentConstants.COPY_EQUIPMENT_FAILURE,
        refreshTableFailurCopy,
      );
      return () => {
        equipmentStore.removeChangeListener(
          equipmentConstants.COPY_EQUIPMENT_SUCCESS,
          refreshTable,
        );
        equipmentStore.removeChangeListener(
          equipmentConstants.COPY_EQUIPMENT_FAILURE,
          refreshTableFailurCopy,
        );
      };
    }, [tableData, itemSelectedFilter]);

    useEffect(() => {
      function refreshTable() {
        toast.success(localization.deleteSuccess);
        const _tempFilterlist = attachingDropDown(
          [...itemSelectedFilter],
          state,
          reportCode,
        );
        // handleEquipmentListApi(
        //   _tempFilterlist,
        //   tableData.paginationData.currentPage,
        //   tableData.paginationData.pageSize,
        // );
        setApiArgs((prev) => ({
          ...prev,
          page: tableData.paginationData.currentPage,
          pageSize: tableData.paginationData.pageSize,
          rawFilterList: _tempFilterlist,
        }));
        setShouldFetch(true);
      }
      function refreshTableFailurDel() {
        const res = equipmentStore.getResult();
        setGlobalSpinner(false);
        toast.error(res);
      }
      equipmentStore.addChangeListener(
        equipmentConstants.DELETE_EQUIPMENT_SUCCESS,
        refreshTable,
      );
      equipmentStore.addChangeListener(
        equipmentConstants.DELETE_EQUIPMENT_FAILURE,
        refreshTableFailurDel,
      );
      //RefreshData();

      return () => {
        equipmentStore.removeChangeListener(
          equipmentConstants.DELETE_EQUIPMENT_SUCCESS,
          refreshTable,
        );
        equipmentStore.removeChangeListener(
          equipmentConstants.DELETE_EQUIPMENT_FAILURE,
          refreshTableFailurDel,
        );
      };
    }, [tableData, itemSelectedFilter]);

    useEffect(() => {
      function handleScrapEquipSuccess() {
        toast.success(localization.deleteSuccess);
        const _tempFilterlist = attachingDropDown(
          [...itemSelectedFilter],
          state,
          reportCode,
        );
        // handleEquipmentListApi(
        //   _tempFilterlist,
        //   tableData.paginationData.currentPage,
        //   tableData.paginationData.pageSize,
        // );
        setApiArgs((prev) => ({
          ...prev,
          page: tableData.paginationData.currentPage,
          pageSize: tableData.paginationData.pageSize,
          rawFilterList: _tempFilterlist,
        }));
        setShouldFetch(true);
      }
      function handleScrapEquipFailure() {
        const res = equipmentStore.getScrapEquipmentResult();
        setGlobalSpinner(false);
        toast.error(res);
      }
      equipmentStore.addChangeListener(
        equipmentConstants.SCRAP_EQUIPMENT_SUCCESS,
        handleScrapEquipSuccess,
      );
      equipmentStore.addChangeListener(
        equipmentConstants.SCRAP_EQUIPMENT_FAILURE,
        handleScrapEquipFailure,
      );
      //RefreshData();

      return () => {
        equipmentStore.removeChangeListener(
          equipmentConstants.SCRAP_EQUIPMENT_SUCCESS,
          handleScrapEquipSuccess,
        );
        equipmentStore.removeChangeListener(
          equipmentConstants.SCRAP_EQUIPMENT_FAILURE,
          handleScrapEquipFailure,
        );
      };
    }, [tableData, itemSelectedFilter]);

    useEffect(() => {
      function updateData() {
        toast.success(localization.updateSuccess);
        const _tempFilterlist = attachingDropDown(
          [...itemSelectedFilter],
          state,
          reportCode,
        );
        // handleEquipmentListApi(
        //   _tempFilterlist,
        //   tableData.paginationData.currentPage,
        //   tableData.paginationData.pageSize,
        // );
        setApiArgs((prev) => ({
          ...prev,
          page: tableData.paginationData.currentPage,
          pageSize: tableData.paginationData.pageSize,
          rawFilterList: _tempFilterlist,
        }));
        setShouldFetch(true);
        // handleEquipmentListApi([...conditions], state, true);
      }
      function updateFailur() {
        toast.success(localization.updateError);
        setGlobalSpinner(false);
      }

      equipmentStore.addChangeListener(
        equipmentConstants.UPDATE_EQUIPMENTSTATUS_SUCCESS,
        updateData,
      );
      equipmentStore.addChangeListener(
        equipmentConstants.UPDATE_EQUIPMENTSTATUS_FAILURE,
        updateFailur,
      );
      return () => {
        equipmentStore.removeChangeListener(
          equipmentConstants.UPDATE_EQUIPMENTSTATUS_SUCCESS,
          updateData,
        );
        equipmentStore.removeChangeListener(
          equipmentConstants.UPDATE_EQUIPMENTSTATUS_FAILURE,
          updateFailur,
        );
      };
    }, [tableData, itemSelectedFilter]);

    function handelPopOverClose() {
      setEquipmentPopover({
        isOpen: false,
        selectedItem: null,
      });
    }

    function handleDelEquPoPClose(isDelete) {
      if (isDelete) {
        setMessageBoxProperty(messageBoxInitial);
      }
      setMessageBoxProperty((prev) => {
        return { ...prev, delequipmentDetails: {}, isOpenDeletePopOver: false };
      });
    }

    function handelMultiplePruefPlaneDialogClose() {
      setMultiplePruefPlan({ isOpen: false, selectedItem: null });
    }

    function handleClosePopOver() {
      setOrderHistroy({ isOpen: false, eqID: "" });
    }

    function handleMultipleActive(item) {
      setGlobalSpinner(true);

      equipmentActions.UpdateEquipmentStatus(
        selectedEqList ? selectedEqList : [item.id],
        "INBE",
        sessionStorage.getItem("userid"),
      );
    }

    function handleFilterSave(_filterList, key, fieldName, _id) {
      let filterValue = [];
      const { filterList, IsAnlageLastCheckValue, fieldFound } =
        FilterApplyHandle(
          _filterList,
          state,
          reportCode,
          tableData.headerName,
          tableData.hearderType,
        );
      const filterDetails = {
        ID: _id,
        eqgID: sessionStorage.getItem("eqGId"),
        ReportCode: reportCode,
        SettingType: "Filter",
        Title: fieldName,
        SettingValue: filterList,
      };

      setGlobalSpinner(true);
      GridColumn_SettingActions.saveFilterGrid(filterDetails);
      filterValue = filterList;

      if (!fieldFound && state !== "All") {
        filterValue.push(
          dropDownFilter(
            reportCode === "EquipList" ? "AnlageStatus" : "LastCheckDate",
            state,
          ),
        );
      }
      if (IsAnlageLastCheckValue) {
        setState(IsAnlageLastCheckValue);
        updateEquipmentStatus(IsAnlageLastCheckValue);
      }
    }

    function handleFilter(_filterList, key, fieldName) {
      let filterValue = [];
      if (["apply"].includes(key)) {
        const { filterList, IsAnlageLastCheckValue, fieldFound } =
          FilterApplyHandle(
            _filterList,
            state,
            reportCode,
            tableData.headerName,
            tableData.hearderType,
          );

        filterValue = filterList;

        if (
          itemSelectedFilterRef?.current.length > 0 &&
          !CompareFilter(itemSelectedFilterRef.current, filterValue)
        ) {
          updateSelectedFilter("");
        }
        updateListSelectedFilter([...filterValue]);
        if (!fieldFound && state !== "All") {
          filterValue.push(
            dropDownFilter(
              reportCode === "EquipList" ? "AnlageStatus" : "LastCheckDate",
              state,
            ),
          );
        }
        if (IsAnlageLastCheckValue) {
          setState(IsAnlageLastCheckValue);
          updateEquipmentStatus(IsAnlageLastCheckValue);
        }
      } else {
        if (state !== "All") {
          filterValue.push(
            dropDownFilter(
              reportCode === "EquipList" ? "AnlageStatus" : "LastCheckDate",
              state,
            ),
          );
        }
        updateListSelectedFilter([]);
        updateSelectedFilter("");
      }

      //handleEquipmentListApi(filterValue, 1, tableData.paginationData.pageSize);
      setApiArgs((prev) => ({
        ...prev,
        rawFilterList: filterValue,
        page: 1,
        pageSize: tableData.paginationData.pageSize,
      }));
      setShouldFetch(true);
    }

    function handlePagination(pageModel, _filterList) {
      const _tempFilterlist = attachingDropDown(
        [..._filterList],
        state,
        reportCode,
      );
      handlePaginationCallApi(pageModel, _tempFilterlist);
    }

    function handleDropDownApiCall(stateValue, filterModel) {
      const { updatedConditions, dropDownCondition } = DropDownChange(
        stateValue,
        filterModel,
        reportCode,
      );

      setTableData(null);
      updateListSelectedFilter(updatedConditions);

      const tempFilter =
        dropDownCondition.length > 0
          ? [...updatedConditions, ...dropDownCondition]
          : updatedConditions;

      //handleEquipmentListApi(tempFilter, 1, tableData.paginationData.pageSize);
      setApiArgs((prev) => ({
        ...prev,
        rawFilterList: tempFilter,
        page: 1,
        pageSize: tableData.paginationData.pageSize,
      }));
      setShouldFetch(true);
    }

    function handleSorting(sortingModal, _filterList) {
      // const _tempFilterlist = attachingDropDown(
      //   [..._filterList],
      //   state,
      //   reportCode,
      // );

      setApiArgs((prev) => ({
        ...prev,
        rawFilterList: _filterList,
        page: 1,
        pageSize: tableData.paginationData.pageSize,
        isSorting: true,
        sortingModal,
      }));

      setShouldFetch(true);
      // handleEquipmentListApi(
      //   _tempFilterlist,
      //   1,
      //   tableData.paginationData.pageSize,
      //   true,
      //   sortingModal,
      // );
      UpdateSortBy({
        key: sortingModal ? sortingModal[0]["field"] : "InventarNr",
        order: sortingModal ? sortingModal[0]["sort"] : "asc",
      });
    }

    function handleGridSettingChange(_filterList) {
      const _tempFilterlist = attachingDropDown(
        [..._filterList],
        state,
        reportCode,
      );
      setTableData(null);

      setShouldFetch(true);
      // handleEquipmentListApi(
      //   _tempFilterlist,
      //   tableData.paginationData.currentPage,
      //   tableData.paginationData.pageSize,
      // );
      setApiArgs((prev) => ({
        ...prev,
        rawFilterList: _tempFilterlist,
        page: tableData.paginationData.currentPage,
        pageSize: tableData.paginationData.pageSize,
      }));
      setShouldFetch(true);
    }

    function handleExport(_values) {
      setMessageBoxProperty(_values);
    }

    const [isCombinedPdf, setIsCombinedPdf] = useState(false);

    const handleBulkExportInspectionReport = (
      fromDate,
      ToDate,
      combineIntoSinglePdf,
    ) => {
      const firstDayFormatted = dateFormat(fromDate, "dd.mm.yyyy");
      const lastDayFormatted = dateFormat(ToDate, "dd.mm.yyyy");
      let _tempFilterlist = attachingDropDown(
        [...itemSelectedFilter],
        state,
        reportCode,
      );

      _tempFilterlist.push({
        Name: "LastCheckDate",
        Operator: ">=",
        Value: firstDayFormatted,
        mapping: "onOrAfter",
      });

      _tempFilterlist.push({
        Name: "LastCheckDate",
        Operator: "<=",
        Value: lastDayFormatted,
        mapping: "onOrBefore",
      });

      setIsCombinedPdf(combineIntoSinglePdf);
      setGlobalSpinner(true);
      equipmentGroupActions.bulkExportInspectionReport(
        reportCode,
        sortBy.order,
        selectedAnlageG,
        1,
        100,
        "InventarNr",
        null,
        _tempFilterlist,
        combineIntoSinglePdf,
      );
    };

    function handelStateStatus(_filterModel) {
      if (_filterModel.name === "AnlageStatus") {
        if (_filterModel.value !== state) {
        }
      }
    }

    function handleBulkOperationSuccess() {
      const _tempFilterlist = attachingDropDown(
        [...itemSelectedFilter],
        state,
        reportCode,
      );
      // handleEquipmentListApi(
      //   _tempFilterlist,
      //   tableData.paginationData.currentPage,
      //   tableData.paginationData.pageSize,
      // );
      setApiArgs((prev) => ({
        ...prev,
        rawFilterList: _tempFilterlist,
        page: tableData.paginationData.currentPage,
        pageSize: tableData.paginationData.pageSize,
      }));
      setShouldFetch(true);
    }

    const handleBulkInspectionReportDownload = useCallback(
      (exportData, isCombined) => {
        if (exportData !== null && exportData !== undefined) {
          const url = window.URL.createObjectURL(exportData);
          let a = document.createElement("a");
          const extension = isCombined ? "pdf" : "zip";
          let name =
            "InspectionReport_" +
            dateFormat(Date(), "yyyy-mm-dd_hh-mm-ss") +
            "." +
            extension;

          a.hidden = "";
          a.href = url;
          a.download = name;
          a.click();
          setGlobalSpinner(false);
        }

        return () => {};
      },
      [],
    );

    useEffect(() => {
      function getBulkExportInspectionReportSuccess() {
        const res = equipmentGroupStore.getBulkExportInspectionReportRes();
        handleBulkInspectionReportDownload(res, isCombinedPdf);
        setGlobalSpinner(false);
      }
      function getBulkExportInspectionReportFailure() {
        const res = equipmentGroupStore.getBulkExportInspectionReportRes();
        toast.error(localization.noReportFoundError);
        setGlobalSpinner(false);
      }

      equipmentGroupStore.addChangeListener(
        equipmentGroupConstants.GET_BULK_INSPECTION_REPORT_SUCCESS,
        getBulkExportInspectionReportSuccess,
      );
      equipmentGroupStore.addChangeListener(
        equipmentGroupConstants.GET_BULK_INSPECTION_REPORT_FAILURE,
        getBulkExportInspectionReportFailure,
      );
      return () => {
        equipmentGroupStore.removeChangeListener(
          equipmentGroupConstants.GET_BULK_INSPECTION_REPORT_SUCCESS,
          getBulkExportInspectionReportSuccess,
        );
        equipmentGroupStore.removeChangeListener(
          equipmentGroupConstants.GET_BULK_INSPECTION_REPORT_FAILURE,
          getBulkExportInspectionReportFailure,
        );
      };
    }, [handleBulkInspectionReportDownload, isCombinedPdf]);

    return (
      <>
        {tableData && (
          <MuiDataGridPro
            tableData={tableData}
            clearFilterKey={clearFilterKey}
            handlePaginationCall={handlePagination}
            handleFilter={handleFilter}
            saveFilterHandler={handleFilterSave}
            pinnedColumns={pinnedColumns}
            handleColumnPin={handleColumnPin}
            handleSorting={handleSorting}
            reportCode={reportCode}
            handelStateStatus={handelStateStatus}
            saveFilterlist={saveFilterlist}
            state={state}
            onRowDoubleClick={handleRowDoubleClick}
          >
            <GridHeaderBar
              handleDropChange={handleDropDownApiCall}
              reportCode={reportCode}
              gridAction={tableData.gridAction}
              rowCount={tableData.paginationData.rowCount}
              selectedEqList={selectedEqList}
              handleMultipleActive={handleMultipleActive}
              state={state}
              setState={setState}
              handleGridSettingChange={handleGridSettingChange}
              hasRow={
                tableData
                  ? tableData.paginationData.rowCount > 0
                    ? true
                    : false
                  : false
              }
              handleExport={handleExport}
              handleBulkOperationSuccess={handleBulkOperationSuccess}
              handleOpenEquipmentGrpConf={handleOpenEquipmentGrpConf}
              handleBulkExportInspectionReport={
                handleBulkExportInspectionReport
              }
            />
          </MuiDataGridPro>
        )}

        {showGridColumn && (
          <GridColumnSettingControl
            pageId={reportCode}
            handleCloseModel={handleCloseGridColSettingModal}
          />
        )}
        <CopyBox
          isOpen={copyBoxProperty.copyboxOpen}
          text={copyBoxProperty.messageBoxText}
          functions={copyBoxProperty.msgButtons}
          close={closeMsg}
          copyAnzahl={copyBoxProperty.copyAnzahl}
          placeholderName={localization.placeholder}
          _type="number"
        />
        <MessageBox
          isOpen={messageBoxProperty.messageBoxOpen}
          text={messageBoxProperty.messageBoxText}
          functions={messageBoxProperty.msgButtons}
          close={() => setMessageBoxProperty(messageBoxInitial)}
        />
        {equipmentPopover.isOpen && (
          <EquipmentPopOver
            selectedItem={equipmentPopover.selectedItem}
            handelPopOverClose={handelPopOverClose}
          />
        )}
        {messageBoxProperty.isOpenDeletePopOver && (
          <DeleteEquipment
            delEquipmentDetails={messageBoxProperty.delequipmentDetails}
            handleDelEquPoPClose={handleDelEquPoPClose}
            isOpenDeletePopOver={messageBoxProperty.isOpenDeletePopOver}
          />
        )}

        {multiplePruefPlan.isOpen && (
          <MultiPalPruefPlan
            selectedItem={multiplePruefPlan.selectedItem}
            handelMultiplePruefPlaneDialogClose={
              handelMultiplePruefPlaneDialogClose
            }
          />
        )}
        {orderHistroy.isOpen && (
          <OrderHistroy
            isorderHistroy={orderHistroy.isOpen}
            equipmentID={orderHistroy.eqID}
            handleClosePopOver={handleClosePopOver}
          />
        )}
      </>
    );
  },
);

export default EquipmentListTable;
